// extracted by mini-css-extract-plugin
export default {"profileCard":"ProfileCard_profileCard__-zIe8","name":"ProfileCard_name__Vsscg","university":"ProfileCard_university__hDtKB"};